import React from 'react'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import { COUNTRIES } from '../../Constants'
import { isUK } from '../../services/utils'
import './InsurerLogo.scss'
import BrokerConfigService from '../../services/BrokerConfigService'
import { useLocation } from 'react-router-dom'

var classNames = require('classnames')

export const InsurerLogo = () => {
  const location = useLocation()

  const path = `${process.env.PUBLIC_URL}/assets/markel_logo.jpg`

  return (
    <img
      className={classNames(
        { 'insurer-logo-us': FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.US },
        { 'insurer-logo-us': FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.CANADA },
        { 'insurer-logo-uk': isUK() }
      )}
      src={path}
    />
  )
}
